import type { CapabilityBinding } from '../../core/types';

export const MI_CAPABILITIES = [
  {
    key: 'base-info',
    pathPrefix: '',
    options: {
      nameField: 'alias',
      nameMaxLength: 64,
      descriptionMaxLength: false,
      descriptionRows: 8,
    },
  },
  {
    key: 'runtime-config',
    pathPrefix: '',
  },
  {
    key: 'maas-model-storage',
    pathPrefix: '',
  },
  {
    key: 'maas-system-config',
    pathPrefix: '',
  },
  {
    key: 'service',
    pathPrefix: '',
    options: { valueFormat: 'json-string' },
  },
  {
    key: 'env-vars',
    pathPrefix: '',
    options: { useCard: false, listSegment: 'commonEnv' },
  },
  {
    key: 'maas-image-storage',
    pathPrefix: '',
  },
  {
    key: 'maas-node-groups',
    pathPrefix: '',
  },
  {
    key: 'maas-gateway-nodes',
    pathPrefix: '',
  },
  {
    key: 'mi-kv-offload',
    pathPrefix: '',
  },
  {
    key: 'maas-command-args-normal',
    pathPrefix: 'initCommand',
  },
  {
    key: 'maas-task-template',
    pathPrefix: '',
  },
  {
    key: 'health-check',
    pathPrefix: '',
  },
] as const satisfies readonly CapabilityBinding[];
